import React from 'react';
import { Supplier } from '../../model/supplier';
import { entityManagerProvider } from '../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card, Table } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
import { Country } from '../../model/country';

interface SupplierList {
  supplier: Supplier[];
  countries: Country[];
  selected: Supplier;
  ids: number;
  loading: boolean;
}

class Suppliers extends React.Component<any, SupplierList> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      supplier: [] as Supplier[],
      countries: [] as Country[],
      selected: null as Supplier,
      ids: 0 as number,
      loading: true,
    };
    this.manager = entityManagerProvider.newManager();

    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.addSupplier = this.addSupplier.bind(this);
    this.remove = this.remove.bind(this);
    this.cancleSelection = this.cancleSelection.bind(this);
  }

  cancleSelection() {
    this.rejectChanges();
  }
  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('Suppliers').expand('country');
    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        selected: null,
        supplier: qr.results,
        loading: false,
      });
    });

    const countriesQuery = new EntityQuery('Countries');

    this.manager.executeQuery(countriesQuery).then((countriesQr) => {
      this.setState({
        countries: countriesQr.results,
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }
  addSupplier() {
    this.setState({
      ids: this.state.ids - 1,
    });
    let supplier = this.manager.createEntity(Supplier.prototype.entityType, {
      applicationUserId: this.props.authorizedUser.Id,
      createdOn: new Date(),
      modifiedOn: new Date(),
      supplierId: this.state.ids,
      countryId: 0,
    }) as Supplier;
    // supplier.applicationUserId = this.props.authorizedUser.Id;
    // supplier.createdOn = new Date();
    // supplier.modifiedOn = new Date();
    // supplier.supplierId = this.state.ids;
    // supplier.countryId = 0;
    // select the new supplier, and add it to the list of suppliers
    this.setState({
      selected: supplier,
      supplier: this.state.supplier.concat([supplier]),
    });
  }

  remove(ent: Supplier) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }
  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }
  saveChanges() {
    this.setState({
      loading: true,
    });
    this.manager
      .saveChanges()
      .then(() => {
        // refresh supplier list to remove deleted suppliers
        this.setState({
          selected: null,
          supplier: this.manager.getEntities('Supplier') as Supplier[],
          loading: false,
        });
      })
      .catch(function(error) {
        console.log('error catch', error, error.entityErrors);
      })
      .finally(() => {
        const query = new EntityQuery('Suppliers');
        this.manager.executeQuery(query).then((res) => {
          this.setState({
            selected: null,
            supplier: res.results,
            loading: false,
          });
        });
      });
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh supplier list to restore original state
    let suppliers = this.manager.getEntities('Supplier') as Supplier[];
    suppliers = suppliers.sort((a, b) => a.supplierId - b.supplierId);
    this.setState({
      selected: null,
      supplier: suppliers,
    });
  }

  renderPaymentEdit() {
    let supplier = this.state.selected;
    function handleCountryChange(event) {
      supplier.countryId = event.target.value;
    }
    if (supplier) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={
                  !this.manager.hasChanges() &&
                  this.state.selected.countryId > 0
                }
                onClick={this.saveChanges}
              >
                <i className="fa fa-save"></i>
                Save Changes
              </button>
              <button
                className="btn btn-primary ml-2"
                type="button"
                disabled={!this.manager.hasChanges()}
                onClick={this.rejectChanges}
              >
                <i className="fa fa-redo"></i>
                Revert Changes
              </button>
              <button
                className="btn btn-danger ml-2"
                type="button"
                onClick={this.remove.bind(this, supplier)}
              >
                <i className="fa fa-trash"></i>
                Delete
              </button>
            </Card.Header>
            <Card.Body>
              <Card.Title>Supplier Details</Card.Title>

              <form>
                <div className="form-group row">
                  <div className="col-lg-6">
                    <label>Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="supplierName"
                      value={supplier.supplierName || ''}
                      onChange={supplier.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Mobile</label>
                    <input
                      className="form-control"
                      type="text"
                      name="supplierMobile"
                      value={supplier.supplierMobile || ''}
                      onChange={supplier.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Phone</label>
                    <input
                      className="form-control"
                      type="text"
                      name="supplierPhone"
                      value={supplier.supplierPhone || ''}
                      onChange={supplier.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Address</label>
                    <input
                      className="form-control"
                      type="text"
                      name="supplierLocation"
                      value={supplier.supplierLocation || ''}
                      onChange={supplier.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Air Code</label>
                    <input
                      className="form-control"
                      type="text"
                      name="airCode"
                      value={supplier.airCode || ''}
                      onChange={supplier.handleChange}
                    />
                  </div>
                  <div className="col-lg-6">
                    <label>Website</label>
                    <input
                      className="form-control"
                      type="text"
                      name="website"
                      value={supplier.website || ''}
                      onChange={supplier.handleChange}
                    />
                  </div>

                  <div className="col-lg-12">
                    <label>Country</label>
                    <select
                      className="form-control"
                      name="countryId"
                      onChange={handleCountryChange}
                      value={supplier.countryId || 0}
                    >
                      <option key={0} value={0}>
                        Select Country
                      </option>
                      {this.state.countries?.map((country) => {
                        return (
                          <option
                            key={country.countryId}
                            value={country.countryId}
                          >
                            {country.countryName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }
  render() {
    return (
      <div>
        <Card border="primary" style={{ width: '100%' }}>
          <Card.Header>
            <button
              className="btn btn-primary ml-2"
              type="button"
              onClick={this.addSupplier}
            >
              <i className="fa fa-plus"></i>
              Add Supplier
            </button>
            <button
              className="btn btn-warning ml-2"
              type="button"
              onClick={this.cancleSelection}
            >
              <i className="fa fa-undo"></i>
              Cancel
            </button>
          </Card.Header>
          <Card.Body>
            <Card.Title>Supplier List</Card.Title>
            {this.renderPaymentEdit()}
            <div className="card card-custom card-stretch">
              {this.state.loading ? (
                <div className="row" style={{ minHeight: '200px' }}>
                  <Loader
                    size="large"
                    style={{ position: 'relative', margin: '60px auto' }}
                    type="converging-spinner"
                  />
                </div>
              ) : (
                <Table className="table" responsive="sm" bordered>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>Country</th>
                      <th>Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.supplier?.map((supplier, idx) => {
                      return (
                        <tr
                          key={supplier.supplierId}
                          style={{
                            backgroundColor:
                              supplier === this.state.selected
                                ? 'lightgray'
                                : 'white',
                          }}
                          onClick={() => this.setState({ selected: supplier })}
                        >
                          <td>{supplier.supplierId}</td>
                          <td>{supplier.supplierName}</td>
                          <td>{supplier.supplierMobile}</td>
                          <td>{supplier.country?.countryName}</td>
                          <td>{this.dateFormatter(supplier.createdOn)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default Suppliers;
